module.exports = __webpack_public_path__ + "img/login-error.cb9f33e4.png";